<div class="relative w-full h-full">

  <!-- For autoplay, retain the thumbnail until the proxy confirms playback. -->
  @if (showThumbnail() && thumbnailUrl() && (autoplayOnViewport() ? !videoDisplayReady() : !iframeLoaded())) {
    <img
      class="absolute inset-0 w-full h-full object-contain bg-black rounded z-10"
      [src]="thumbnailUrl()"
      alt="video thumbnail"
      loading="lazy"
    />

    <div
      *ngIf="!autoplayOnViewport()"
      class="absolute inset-0 flex items-center justify-center z-20"
    >
      <div class="bg-black/50 rounded-full p-4 text-white">
        &#9658;
      </div>
    </div>
  }

  @if (proxyUrl()) {
    <iframe
      #proxyIframe
      class="w-full h-full rounded object-contain bg-black"
      [class.opacity-0]="showThumbnail() && (autoplayOnViewport() ? !videoDisplayReady() : !iframeLoaded())"
      [class.opacity-100]="!showThumbnail() || (autoplayOnViewport() ? videoDisplayReady() : iframeLoaded())"
      [src]="proxyUrl()"
      frameborder="0"
      allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
      allowfullscreen
      webkitallowfullscreen
      mozallowfullscreen
      (load)="onIframeLoad()"
    ></iframe>
  }
</div>
